export default function SVGPhone(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="14.8359" y="4" width="34" height="56" rx="3" stroke="#757575" strokeWidth="2" />
            <path d="M29.3359 8H34.6693" stroke="#757575" strokeWidth="1.77778" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M26.002 57H38.002" stroke="#757575" strokeWidth="1.77778" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
